/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ParametresRechercheDocuments { 
    categories?: Array<string>;
    formats?: Array<string>;
    cadreExercice?: Array<string>;
    /**
     * Rechercher les document à partir de cette date
     */
    dateDebutActe?: string;
    /**
     * Rechercher les documents jusqua\'à cette date
     */
    dateFinActe?: string;
    /**
     * Rechercher les documents à partir de cette date
     */
    dateCreationDebut?: string;
    /**
     * Rechercher les documents jusqua\'à cette date
     */
    dateCreationFin?: string;
    /**
     * Rechercher les document à partir de cette date
     */
    dateEnvoiDebut?: string;
    /**
     * Rechercher les documents jusqua\'à cette date
     */
    dateEnvoiFin?: string;
    /**
     * 1=Document validé par un Professionnel de santé; 2=Document archivé; 3=Document obsolète; 4=Document supprimé
     */
    statut?: ParametresRechercheDocuments.StatutEnum;
    /**
     * Code d\'un code d\'interopérabilité récupérable via la route \'/codesInteroperabilite\' en utilisant le paramètre DOCUMENT_CONFIDENTIALITY
     */
    visibilite?: string;
    /**
     * Rechercher également les documents masqués
     */
    documentsMasques?: boolean;
    /**
     * Rechercher également les documents obsolètes
     */
    documentsObsoletes?: boolean;
}
export namespace ParametresRechercheDocuments {
    export type StatutEnum = 1 | 2 | 3 | 4;
    export const StatutEnum = {
        NUMBER_1: 1 as StatutEnum,
        NUMBER_2: 2 as StatutEnum,
        NUMBER_3: 3 as StatutEnum,
        NUMBER_4: 4 as StatutEnum
    };
}


